@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1>Channels</h1>
</div>
<p class="lead">
  Channels correspond to data types in Macro. Channels may be converted to non-standard units by configuring a conversion.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align: right">
    <a
      id="createChannel"
      class="btn btn-large btn-primary"
      (click)="nextPage($event, '/createChannel', router)"
      style="margin-top: 9px"
    >
      Create Channel</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Channels...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>Channel ID</th>
      <th>Channel name</th>
      <th>Units</th>
      <th>Conversions</th>
      <th>Powertypes</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="Channel ID" class="input-sm form-control" type="search" [(ngModel)]="channelIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Channel Name" class="input-sm form-control" type="search" [(ngModel)]="channelNameSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th></th>
      <th></th> <!-- No search for Powertypes (complex nested data) -->
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(channel of displayedChannels | paginate: paginationModel; track channel) {
        <tr class='table-active'>
          <td>{{channel.id}}</td>
          <td>{{channel.display_label}}</td>
          <td>{{channel.siScaleCode}}{{channel.itemUnit}}</td>
          <td>
            @for(channel_powertype of channel.channel_powertypes; track channel_powertype){
              <div>{{channel_powertype.conversion?.description}}</div>
            }
          </td>
          <td>
            @for(channel_powertype of channel.channel_powertypes; track channel_powertype){
              <div>
                {{channel_powertype.powertype?.itemLabel}}
                ({{channel_powertype.powertype?.siScaleCode}}{{channel_powertype.powertype?.itemUnit}})
                {{channel_powertype.powertype?.hertz}}Hz {{channel_powertype.powertype?.voltage}}V
              </div>
            }
          </td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a
                  class="btn btn-default"
                  (click)="nextPage(channel.id, '/editChannel', router)"
                  id="editChannel"
                >Edit</a>
                <button
                  class="btn btn-danger"
                  type="button"
                  (click)="delete(channel)"
                >
                  Delete
                </button>
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedChannels.length === 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 6 : 5" style="text-align: center;">No channels found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 6 : 5">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
